import React from 'react';
import { Container, NavbarBrand, Row, Col} from 'reactstrap';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

import img1 from '../../assets/images/contents/ccis.png';
import book1 from '../../assets/images/contents/book1.jpg';
import book2 from '../../assets/images/contents/book2.png';
import book4 from '../../assets/images/contents/book5.jpg';

export const Publication = () => (
  <div>
  <Helmet>
    <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Publication</title>
  </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item"><a href="/">Information</a></li>
        <li class="breadcrumb-item active" aria-current="page">Publication</li>
      </ol>
    </nav>
    <h3>Proceeding</h3>
    <p style={{ textAlign:'justify'}}>All accepted and registered papers of SCDS2021 will be submitted to be indexed in the renowned series of &quot;Communications 
      in Computer and Information Science series&quot; by Springer Verlag.
    </p>   

    <Container>
      <Row>
        <Col lg="5" className="m-b-30">                                              
          <img src={img1} alt="img" className="img-responsive img-rounded" width="250" />
          <p className="m-t-15 m-b-0"></p>
        </Col>                     
      </Row>
    </Container> 

    <h3>Journal</h3>
    <p>Authors of accepted papers will be invited to submit extended paper to:</p>
    <p>{'\u2022'} Applied Soft Computing, Elsevier.(Q1: Fast Track Submission) <br/>
    {'\u2022'} Journal of Information and Communication Technology (JICT) <br/> &nbsp; 
                                    (uum.edu.my) (Q2) <br/>
    {'\u2022'} Pertanika Journal of Science and Technology (with additional publication charge of RM750) <br/> &nbsp;  
                                    http://pertanika.upm.edu.my/JST.php (Q3) 
    </p>

    <NavbarBrand><img src={book1} alt="wrapkit" height= "180px" width= "130px"/></NavbarBrand>                       
                                    <NavbarBrand><img src={book4} alt="wrapkit" height= "180px" width= "130px"/></NavbarBrand>
                                    <NavbarBrand><img src={book2} alt="wrapkit" height= "180px" width= "130px"/></NavbarBrand><br/><br/>

  </div>
)